import type { MarkerFeature } from "../../../../../utils/models/MarkerFeature";
import type { LineStringFeature } from "../../../../../utils/models/LineStringFeature";
import type { UndoCommand, CommandContext } from "../types";

export class RemoveAllControlPointsCommand implements UndoCommand {
  readonly type = 'REMOVE_ALL_CONTROL_POINTS';
  readonly routeKey: string;

  private markersBefore: MarkerFeature[];
  private lineStringsBefore: LineStringFeature[];
  private markersAfter: MarkerFeature[];
  private lineStringsAfter: LineStringFeature[];

  constructor(data: {
    routeKey: string;
    markersBefore: MarkerFeature[];
    lineStringsBefore: LineStringFeature[];
    markersAfter: MarkerFeature[];
    lineStringsAfter: LineStringFeature[];
  }) {
    this.routeKey = data.routeKey;
    this.markersBefore = JSON.parse(JSON.stringify(data.markersBefore));
    this.lineStringsBefore = JSON.parse(JSON.stringify(data.lineStringsBefore));
    this.markersAfter = JSON.parse(JSON.stringify(data.markersAfter));
    this.lineStringsAfter = JSON.parse(JSON.stringify(data.lineStringsAfter));
  }

  undo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    route.markers = JSON.parse(JSON.stringify(this.markersBefore));
    route.lineStrings = JSON.parse(JSON.stringify(this.lineStringsBefore));
    route.updated_at = new Date();
  }

  redo(ctx: CommandContext): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    route.markers = JSON.parse(JSON.stringify(this.markersAfter));
    route.lineStrings = JSON.parse(JSON.stringify(this.lineStringsAfter));
    route.updated_at = new Date();
  }
}
